'use strict';

// Webphone logger class
var WebphoneLogger = function() {
    this.enabled = false;
    this.addTime = false;
    this._zeroFillData = '0000000000';  // max number of zero fill ever asked for in global
    this.blockClasses = [];
    this.blockMethods = [];
    this.shortenClassNames = {
        Webphone: '[P]',
        WebphoneAudio: '[A]',
        WebphoneSession: '[S]',
        WebphoneUI: '[UI]',
        WebphoneModalWindow: '[MW]',
    };
    this.cOriginal = console;
};

WebphoneLogger.prototype._zeroFill = function(number, width) {
    var input = number + '';  // make sure it's a string
    return(this._zeroFillData.slice(0, width - input.length) + input);
};

WebphoneLogger.prototype._currentTimeString = function() {
    var d = new Date();

    var dd = this._zeroFill(d.getDate(), 2);
    var mm = this._zeroFill(d.getMonth() + 1, 2); // Months are zero-based
    var yyyy = d.getFullYear();

    var HH = this._zeroFill(d.getHours(), 2);
    var MM = this._zeroFill(d.getMinutes(), 2);
    var SS = this._zeroFill(d.getSeconds(), 2);
    var SSS = this._zeroFill(d.getMilliseconds(), 3);

    return yyyy + '-' + mm + '-' + dd + ' ' + HH + ':' + MM + ':' + SS + '.' + SSS;
};

WebphoneLogger.prototype.isBlocked = function(className, methodName) {

    if (this.blockClasses[className])
        return true;

    if (this.blockMethods[methodName])
        return true;

    return false;
};

WebphoneLogger.prototype._formatMessage = function(className, methodName, data, addTime) {

    if (typeof addTime !== 'bool')
        addTime = this.addTime;

    var result = addTime ? this._currentTimeString() : '';

    if (methodName && className) {

        if (result)
            result += ' ';

        if (className
            && typeof this.shortenClassNames[className] !== 'undefined') {

            result += this.shortenClassNames[className] + '.' + methodName;

        } else if (className.indexOf('WebphoneSession') === 0) {

            result += className.replace(/^WebphoneSession/, '[') + '].' + methodName;

        } else {
            result += className + '.' + methodName;
        }
    }

    if (result)
        result += ' ';

    if (typeof data === 'string')
        result += data;
    else
        result += this._dump(data);

    return result;
};

WebphoneLogger.prototype.log = function(className, methodName, data) {
    if (!this.enabled)
        return false;

    if (this.isBlocked(className, methodName))
        return false;

    var message = this._formatMessage(className, methodName, data);

    this.cOriginal.log(message);

    // Write to HTML page
    jQuery('.debug .log ul').prepend('<li><span class="time">' + this._currentTimeString() + '</span><span class="message">' + this._formatMessage(className, methodName, data, false) + '</span></li>');
    //

    return true;
};

WebphoneLogger.prototype.debug = WebphoneLogger.prototype.log;


WebphoneLogger.prototype.info = function(className, methodName, data) {
    if (!this.enabled)
        return false;

    if (this.isBlocked(className, methodName))
        return false;

    var message = this._formatMessage(className, methodName, data);

    this.cOriginal.info(message);

    // Write to HTML page
    jQuery('.debug .log ul').prepend('<li class="warn"><span class="time">' + this._currentTimeString() + '</span><span class="message info">' + this._formatMessage(className, methodName, data, false) + '</span></li>');
    //

    return true;
};


WebphoneLogger.prototype.warn = function(className, methodName, data) {
    if (!this.enabled)
        return false;

    if (this.isBlocked(className, methodName))
        return false;

    var message = this._formatMessage(className, methodName, data);

    this.cOriginal.warn(message);

    // Write to HTML page
    jQuery('.debug .log ul').prepend('<li class="warn"><span class="time">' + this._currentTimeString() + '</span><span class="message warn">' + this._formatMessage(className, methodName, data, false) + '</span></li>');
    //

    return true;
};


WebphoneLogger.prototype.error = function(className, methodName, data) {
    if (!this.enabled)
        return false;

    if (this.isBlocked(className, methodName))
        return false;

    var message = this._formatMessage(className, methodName, data);

    this.cOriginal.error(message);

    // Write to HTML page
    jQuery('.debug .log ul').prepend('<li class="error"><span class="time">' + this._currentTimeString() + '</span><span class="message error">' + this._formatMessage(className, methodName, data, false) + '</span></li>');
    //

    return true;
};


WebphoneLogger.prototype._dump = function(data, level, dumpedObjects, params) {

    if (typeof params !== 'object')
        params = {};

    if (typeof params.maxLevel === 'undefined')
        params.maxLevel = 5;

    if (typeof params.functions === 'undefined')
        params.functions = false;

    if (typeof level === 'undefined')
        level = 0;

    var indent = level ? new Array(level + 1).join("\t") : '';
    var indentPlus = indent + "\t";

    if (level > params.maxLevel)
        return '[level > ' + params.maxLevel + ']';

    if (typeof data === 'boolean') {
        return data ? 'true' : 'false';

    } else if (typeof data === 'string') {
        return '"' + data + '"';

    } else if (typeof data === 'number') {
        return data;

    } else if (typeof data === 'function') {

        return '[function]';

    } else if (data === null) {

        return 'null';

    } else if (typeof data === 'object') {

        if (typeof dumpedObjects === 'undefined')
            dumpedObjects = [];

        for (var doIdx in dumpedObjects) {
            var dObj = dumpedObjects[doIdx];

            if (data === dObj) {
                return '{} // ^^^' + doIdx;
            }
        }

        if (data === this)
            return '{} // ^^^ __The_One_Who_Dump__';

        if (typeof data.toString === 'function'
            && data.toString().indexOf('[object HTML') === 0)
            return data.toString();

        if (data instanceof Date) {
	    var d = data;

	    var dd = this._zeroFill(d.getDate(), 2);
	    var mm = this._zeroFill(d.getMonth() + 1, 2); //Months are zero-based
	    var yyyy = d.getFullYear();

	    var HH = this._zeroFill(d.getHours(), 2);
	    var MM = this._zeroFill(d.getMinutes(), 2);
	    var SS = this._zeroFill(d.getSeconds(), 2);
	    var SSS = this._zeroFill(d.getMilliseconds(), 3);

	    var tzOffset = 0 - d.getTimezoneOffset();
	    var tzHours = Math.floor(tzOffset / 60);
	    var tzMinutes = Math.abs(Math.floor(tzOffset - tzHours*60));
	    var tzStr = (tzOffset >= 0 ? '+' : '-') + this._zeroFill(Math.abs(tzHours),2) + this._zeroFill(tzMinutes,2);

	    return 'new Date("' + yyyy + '-' + mm + '-' + dd + ' ' + HH + ':' + MM + ':' + SS + '.' + SSS + ' ' + tzStr + '")';
	}

        if (Object.keys(data).length === 0)
            return '{}';

        dumpedObjects.push(data);
        var objIdx = dumpedObjects.length - 1;

        var result = '';
	var lastDumpResult = '';

        for (var i in data) {
            var value = data[i];

            // Hide functions?
            if (!params.functions
                && typeof value === 'function')
                continue;

            if (result) {
		if (!lastDumpResult.match(/^\{\}, \/\//))
		    result = result + ",";
            }
	    
	    lastDumpResult = '' + this._dump(value, level + 1, dumpedObjects);
	    lastDumpResult = lastDumpResult.replace(/^\{\} \/\//,'{}, //');

            result = result + "\n" + indentPlus + '"' + i + '"' + ': ' + lastDumpResult;
        }
        return (level ? '' : "\n") + '{ //' + objIdx + ': ' + result + "\n" + indent + '}';
    }
};

WebphoneLogger.prototype._dumpError = function(err) {

    var out = '';
    var addComma = false;

    if (typeof err !== 'undefined') {

        var toString = typeof err.toString === 'function' ? err.toString() : '';
        var name = typeof err.name !== 'undefined' ? err.name : '';
        var stack = typeof err.stack !== 'undefined' ? err.stack : '';

        if (toString) {
            out = out + ' ' + toString;
            addComma = true;
        }

        if (name
            && name != toString) {

            if (addComma)
                out = out + ',';

            out = out + ' name: ' + name;
        }

        if (stack
            && stack != toString
            && stack != name) {

            if (addComma)
                out = out + ',';

            out = out + ' stack: ' + stack;
        }

        var dump = this._dump(err);

        if (dump.trim() != "[object 0 ]") {
            if (addComma)
                out = out + ',';

            out = out + ' dump: ' + dump;
        }
    }

    return out;
};

WebphoneLogger.prototype.setConsole = function(v) {
    this.cOriginal = v;
};



// Class methods
var loggers = {};
WebphoneLogger.factory = function(channel) {

    if (typeof channel === 'undefined')
        channel = 'default';
    
    if (typeof loggers[channel] === 'undefined')
        loggers[channel] = new WebphoneLogger();

    return loggers[channel];
};



WebphoneLogger.addLoggerMethods = function(Class, className) {

    Class.prototype.debug = function(methodName, data) {
        return this.l.debug(className, methodName, data);
    };

    Class.prototype.info = function(methodName, data) {
        return this.l.info(className, methodName, data);
    };

    Class.prototype.warn = function(methodName, data) {
        return this.l.warn(className, methodName, data);
    };

    Class.prototype.error = function(methodName, data) {
        return this.l.error(className, methodName, data);
    };
};

